module.exports = __webpack_public_path__ + "img/pro_6.1c5159a2.png";